import React, { Component } from 'react';
import styled from 'styled-components';
import i18next from '../../../i18n';
import { Trans, withTranslation } from 'react-i18next';

const Container = styled.div`
  margin-bottom: 2rem;
`;

const Paragraph = styled.div`
  max-width: 700px;
  flex-grow: 1;

  hr {
    width: 50%;
    text-align: left;
  }
`;

const Title = styled.h3`
  margin: 0;
  height: 4rem;
`;

class RegistrationError extends Component {
  render() {
    const t = i18next.t;
    return (
      <Container>
        <Paragraph>
          <Title>{t('signup.error.title')}</Title>
          <Paragraph>
            <Trans 
              i18nKey="signup.error.description" 
              components={[<a href="mailto:toimitus@radiodiodi.fi"> </a>]} />
          </Paragraph>
        </Paragraph>
      </Container>
    );
  }
}

export default withTranslation()(RegistrationError);
